/**
 * Единый источник ключей для local/sessionStorage. Каждое значение
 * именует область, чтобы при поиске по проекту коллизии исключались.
 *
 * Семантика по ТЗ 3.2:
 *   - localStorage  — переживает сессию (видимость и ширины колонок, текущий пользователь)
 *   - sessionStorage — обнуляется при логауте/новой сессии (фильтры, локальный фильтр)
 */
export const STORAGE_KEYS = {
  /** Фильтры/сортировка/страница/snapshotDate (sessionStorage). */
  tableFilterState: 'table_filter_state',
  /** Видимость колонок (localStorage, ТЗ 3.2). */
  tableVisibleColumns: 'table_visible_columns',
  /** Ширины колонок (localStorage, ТЗ 3.2). */
  tableColWidths: 'table_col_widths',
  /** Текущий пользователь, извлечённый из JWT (localStorage). */
  currentUser: 'current_user',
  /** Ширины колонок таблицы пользователей в ЛК (localStorage). */
  userListColWidths: 'userListColWidths',
  /** Ширины колонок таблицы организаций в ЛК (localStorage). */
  companyListColWidths: 'companyListColWidths',
  /** URL, куда вернуть пользователя после логина (sessionStorage). */
  postLoginRedirect: 'post_login_redirect',
  /** Маркер логаута для синхронизации между вкладками (localStorage). */
  logoutBroadcast: 'logout_broadcast',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
